import React from 'react';
import { UserCheck, MicOff } from 'lucide-react';
import { useSecondScreenData } from '../../../../contexts/SecondScreenContext';

// Speaking indicator reuses speaking-ring (plan 03), already applied
// identically by IncidentCommandWidget — not redefined here.
const OnTheCall: React.FC = () => {
  const { state } = useSecondScreenData();
  const tabletop = state?.tabletop;
  const seats = tabletop?.seats ?? [];
  const speaking = tabletop?.speaking ?? null;

  if (seats.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-white/30" style={{ fontSize: '16px' }}>
        No seats bound yet
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full gap-1.5 min-h-0">
      <div className="flex-1 flex flex-col gap-1 overflow-y-auto min-h-0">
        {seats.map((seat) => {
          const isSpeaking = speaking?.personaId === seat.personaId;
          return (
            <div
              key={seat.personaId}
              className={`flex items-center gap-2 rounded px-2 py-1 flex-shrink-0 ${isSpeaking ? 'bg-primary/10' : ''}`}
            >
              <span
                className="flex items-center justify-center w-6 h-6 rounded-full flex-shrink-0"
                style={isSpeaking ? { animation: 'speaking-ring 1.2s ease-in-out infinite' } : undefined}
              >
                <UserCheck size={16} className={seat.muted ? 'text-white/20' : isSpeaking ? 'text-primary' : 'text-white/50'} />
              </span>
              <span className="text-white/90 truncate" style={{ fontSize: '18px' }}>{seat.displayName}</span>
              {seat.muted && <MicOff size={14} className="text-red-400 ml-auto flex-shrink-0" />}
            </div>
          );
        })}
      </div>
      {speaking && (
        <p className="flex-shrink-0 text-white bg-black/40 rounded px-2 py-1.5 leading-snug" style={{ fontSize: '24px' }}>
          <span className="text-primary font-bold">{speaking.displayName}: </span>
          {speaking.text}
        </p>
      )}
    </div>
  );
};

export default OnTheCall;
